import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RenovationProject } from 'app/shared/models/renovation-projects/renovation-project.model';
import { endpoints } from 'environments/endpoints';
import { environment } from 'environments/environment';
import { RenovationProjectBeforeRenovation } from 'app/shared/models/renovation-projects/renovation-project-before-renovation.model';
import { ProcessingFormGroup } from 'app/shared/models/renovation-projects/processing-form.model';
import { CeeProcessingStatus } from 'app/shared/enumerations/statuses.enum';

@Injectable({
  providedIn: 'root'
})
export class RenovationProjectBeforeRenovationService {
  private baseRoute =
    environment.GATEWAY_API + endpoints.renovationProjectBeforeRenovation.baseRoute;
  private subRoutes = endpoints.renovationProjectBeforeRenovation.subRoutes;

  constructor(private _httpClient: HttpClient) {}

  private prepareHeader(): { headers: HttpHeaders } {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    headers = headers.set('Content-Type', 'application/json');
    return { headers: headers };
  }

  getAllAvailableForProcessing(): Observable<RenovationProjectBeforeRenovation[]> {
    return this._httpClient.get<RenovationProjectBeforeRenovation[]>(
      `${this.baseRoute}${this.subRoutes.getAllAvailableForProcessing}`
    );
  }

  getAllProcessingDone(): Observable<RenovationProjectBeforeRenovation[]> {
    return this._httpClient.get<RenovationProjectBeforeRenovation[]>(
      `${this.baseRoute}${this.subRoutes.getAllProcessingDone}`
    );
  }

  getById(id: string): Observable<RenovationProjectBeforeRenovation> {
    return this._httpClient.get<RenovationProjectBeforeRenovation>(
      `${this.baseRoute + this.subRoutes.getById}${id}`
    );
  }

  edit(project: RenovationProjectBeforeRenovation): Observable<RenovationProject> {
    return this._httpClient.put<RenovationProject>(
      `${this.baseRoute + this.subRoutes.update}`,
      project
    );
  }

  updateMultipleCeeProcessingStatus(Data: {
    projectIds: string[];
    newStatus: CeeProcessingStatus;
    isFromPartner?: boolean;
    refusalReasonId?: string;
    message?: string;
    files?: Array<{ fileName: string; contentType: string; Base64Content: string }>;
  }): Observable<void> {
    const dto = {
      ProjectIds: Data.projectIds,
      NewStatus: Data.newStatus,
      IsFromPartner: Data.isFromPartner || false,
      RefusalReasonId: Data.refusalReasonId,
      Message: Data.message,
      Files: Data.files
    };
    return this._httpClient.put<void>(
      `${this.baseRoute + this.subRoutes.updateMultipleCeeProcessingStatus}`,
      dto,
      this.prepareHeader()
    );
  }

  returnToProcessing(id: string): Observable<void> {
    return this._httpClient.put<void>(
      `${this.baseRoute + this.subRoutes.returnToProcessing}${id}`,
      null
    );
  }

  getProcessingFormsQuestions(): Observable<ProcessingFormGroup[]> {
    return this._httpClient.get<ProcessingFormGroup[]>(
      this.baseRoute + this.subRoutes.getProcessingFormsQuestions
    );
  }

  exportExcel(isProcessingDone: boolean): Observable<Blob> {
    return this._httpClient.get(
      `${this.baseRoute}${this.subRoutes.exportExcel}${isProcessingDone}`,
      {
        responseType: 'blob'
      }
    );
  }
}
